import React, { useEffect, useState, createRef } from 'react';
import styles from './ModalLocationInput.module.scss';
import { Input, Button } from 'components/common';
import { inject } from 'mobx-react';
import { EDITOR_MONITOR_STORE, UNLOCATED_SHOTS, EDITOR_TIMELINE_STORE, EDITOR_LOCATIONS_STORE } from 'store';
import { ModalLocationInputProps } from './types';

const ModalLocationInput = (props: ModalLocationInputProps) => {
  const {
    [EDITOR_TIMELINE_STORE]: {
      currentMonitorShotLocation
    },
    [EDITOR_LOCATIONS_STORE]: {
      locationNames
    },
    locations = locationNames.filter(l => l !== UNLOCATED_SHOTS),
    onSubmit,
    closeModal
  } = props;

  const [text, setText] = useState('');
  useEffect(() => {
    setText(currentMonitorShotLocation || '');
  }, [currentMonitorShotLocation]);

  const handleSubmit = (location = text) => {
    onSubmit(location);
    setText('');
    closeModal();
  };

  const refs = {};
  locations.forEach(l => refs[l] = createRef());

  const onKeyDown = ({ which }) => {
    const keyCodes = {
      arrowUp: 38,
      arrowDown: 40
    };
    let index = locations.findIndex(l => l === text);
    let location = null;
    const lastIndex = locations.length - 1;

    switch (which) {
      case keyCodes.arrowUp:
        index--;
        index = index < 0 ? lastIndex : index;
        break;

      case keyCodes.arrowDown:
        index++;
        index = index > lastIndex ? 0 : index;
        break;
    }

    if (index < 0) return;

    location = locations[index];
    setText(location);
    refs[location].current.scrollIntoView();
  };

  return (
    <div className={styles.container}>
      <div>
        <Input
          size='mini'
          placeholder='type location'
          onChange={setText}
          value={text}
          autoFocus
          onEnterKey={handleSubmit}
          onEscKey={closeModal}
          onKeyDown={onKeyDown}
        />
        <div className={`${styles.dropdown} dropdown-container`}>

          {locations.map(location => {
            const isOnFocus = text === location;
            return (
              <Button
                key={location}
                className={`${styles.option} ${isOnFocus && styles.optionFocused}`}
                ref={refs[location]}
                onClick={() => handleSubmit(location)}
              >
                {location}
              </Button>
            );
          }
          )}

        </div>
      </div>
      <Button
        size='mini'
        type='add'
        onClick={() => handleSubmit()}
      >
        OK
      </Button>
    </div>
  );
};

export default inject(EDITOR_TIMELINE_STORE, EDITOR_MONITOR_STORE, EDITOR_LOCATIONS_STORE)(ModalLocationInput);
